import Image from "next/image";

export const Logo: React.FC = () => {
  return (
    <Image
      src="/images/MoveHQ_White.svg"
      alt="MoveHQ logo"
      width={264}
      height={67}
      priority
    />
  );
};

